import { render, staticRenderFns } from "./GiftcardHistory.vue?vue&type=template&id=426a3ba8&"
import script from "./GiftcardHistory.vue?vue&type=script&lang=js&"
export * from "./GiftcardHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports